import {
    SET_INVOICE_LIST,
    SET_INVOICE_LOADING,
    SET_INVOICE_SEARCH_NUMBER,
} from "../actionTypes";

export const setInvoiceList = (invoice_list) => {
    return { type: SET_INVOICE_LIST, payload: invoice_list };
};

export const setInvoiceSearchNumber = (number) => {
    return { type: SET_INVOICE_SEARCH_NUMBER, payload: number };
};

export const setInvoiceListIsLoading = (isLoading) => {
    return { type: SET_INVOICE_LOADING, payload: isLoading };
};
